import { atom, computed } from 'nanostores'
import { buildProductSelectBatched } from '../CheckoutProductSelect/V2/checkoutProductSelect'
import { StoreStates, CouponStates, SummaryStates, SubmittingStates } from './consts'
import { StripeCheckoutStore } from './types'
import { getInitialStripeCheckoutErrors } from './errors'

export function ensureCheckoutStoreInitialized(): StripeCheckoutStore {
  globalThis.Checkout.store = globalThis.Checkout.store ?? {
    state: atom(StoreStates.START),
    coupons: {
      appliedCode: atom(''),
      currentCode: atom(''),
      errorMessage: atom(''),
      state: atom(CouponStates.READY),
    },
    summary: atom<{ state: SummaryStates; data?: any; error?: { message: string } }>({
      state: SummaryStates.WAITING,
      data: {},
    }),
    checkout: {
      step: atom(0),
    },
    submitting: atom({
      state: SubmittingStates.IDLE,
    }),
    criticalErrors: atom(getInitialStripeCheckoutErrors()),
    featureFlags: {},
    selectedOrderDetailId: atom(null),
  }

  globalThis.Checkout.computed = globalThis.Checkout.computed ?? {
    checkoutCart: buildProductSelectBatched(),
  }
  globalThis.Checkout.computed.isCouponReady = computed(
    [globalThis.Checkout.store.state, globalThis.Checkout.computed.checkoutCart],
    (state, cart) => {
      const showAllProductErrors = true

      const pErrors = globalThis.Checkout.utils.productErrors(cart, showAllProductErrors)
      return state == globalThis.Checkout.StoreStates.START && !globalThis.Checkout.utils.hasErrors(pErrors)
    }
  )

  return {
    ...globalThis.Checkout.store,
    ...globalThis.Checkout.computed,
  }
}
